export function IsNumber(nbr: unknown): nbr is number {
    return typeof nbr === 'number' && !Number.isNaN(nbr)
}

export function IsNonZeroNumber(nbr: unknown): nbr is number {
    return typeof nbr === 'number' && nbr !== 0
}

export function IsPositiveNumber(nbr: unknown): nbr is number {
    return typeof nbr === 'number' && nbr > 0
}

export function StringToNumber(value: string): number | null {
    return value.trim() === '' ? null : Number.isNaN(Number(value)) ? null : Number(value)
}

export function Clamp(
    value: number,
    min: number = 0,
    max: number = Number.MAX_SAFE_INTEGER,
): number {
    return Math.max(min, Math.min(value, max))
}

export function Wrap(
    value: number,
    min: number = 0,
    max: number = Number.MAX_SAFE_INTEGER,
): number {
    value = value > max ? min : value
    value = value < min ? max : value

    return value
}
